import { Alert, Snackbar } from '@mui/material';
import { useToast } from '@/shared/hooks/useToast';

export function Toaster() {
  const { toasts, dismiss } = useToast();
  const current = toasts[0];
  if (!current) return null;
  return (
    <Snackbar open autoHideDuration={4000} onClose={() => dismiss(current.id)} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
      <Alert severity={current.tone} variant="filled" onClose={() => dismiss(current.id)}>{current.message}</Alert>
    </Snackbar>
  );
}
